import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box } from "native-base";
import CrosshairCommon from "./CrosshairCommon";
import { crosshairCanvas } from "./useStyles";
export default function Crosshair({ graphData = {}, xMsecRatio, offsetX, }) {
    const [crosshairX, setCrosshairX] = useState(0);
    useEffect(() => {
        const onMouseMove = (e) => { var _a; return setCrosshairX(((_a = e.clientX) !== null && _a !== void 0 ? _a : 0) - (offsetX !== null && offsetX !== void 0 ? offsetX : 0)); };
        window.addEventListener("mousemove", onMouseMove);
        return () => window.removeEventListener("mousemove", onMouseMove);
    }, [offsetX]);
    return (_jsx(Box, Object.assign({ style: crosshairCanvas }, { children: _jsx(CrosshairCommon, { crosshairX: crosshairX, graphData: graphData, xMsecRatio: xMsecRatio }) })));
}
